import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import API from '../api';
import './styles.css';

export default function DriverAccessLogin() {
  const navigate = useNavigate();
  const { username: usernameFromPath } = useParams();
  const [searchParams] = useSearchParams();
  const { t, i18n } = useTranslation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const queryLang = searchParams.get('lang');
    const storedDriverLang = localStorage.getItem('driver_portal_lang');
    const lang = queryLang || storedDriverLang;
    if (lang && ['ar', 'en', 'fr'].includes(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
      localStorage.setItem('driver_portal_lang', lang);
    }

    const fromQuery = searchParams.get('username') || '';
    setUsername(usernameFromPath || fromQuery);
    setPassword(searchParams.get('password') || '');
  }, [i18n, searchParams, usernameFromPath]);

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await API.post(
        'drivers/portal-login/',
        { username, password },
        { skipAuthRedirect: true, skipAuthToken: true }
      );
      localStorage.setItem('driver_portal_token', res.data?.token || '');
      localStorage.setItem('driver_portal_driver', JSON.stringify(res.data?.driver || {}));
      localStorage.setItem('driver_portal_lang', i18n.language || 'en');
      navigate('/driver/home');
    } catch (err) {
      setError(err?.response?.data?.error || t('Invalid username or password'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page driver-login-page">
      <div className="card login-card">
        <h2>{t('Driver Portal Login')}</h2>
        <p className="brand-sub">{t('Enter the credentials shared by your office')}</p>
        {error && <p className="login-error">{error}</p>}

        <div className="row-actions" style={{ marginBottom: 12 }}>
          <button className={`btn ${i18n.language === 'ar' ? 'btn-primary' : 'btn-secondary'}`} type="button" onClick={() => { i18n.changeLanguage('ar'); localStorage.setItem('driver_portal_lang', 'ar'); }}>عربي</button>
          <button className={`btn ${i18n.language === 'fr' ? 'btn-primary' : 'btn-secondary'}`} type="button" onClick={() => { i18n.changeLanguage('fr'); localStorage.setItem('driver_portal_lang', 'fr'); }}>FR</button>
          <button className={`btn ${i18n.language === 'en' ? 'btn-primary' : 'btn-secondary'}`} type="button" onClick={() => { i18n.changeLanguage('en'); localStorage.setItem('driver_portal_lang', 'en'); }}>EN</button>
        </div>

        <form onSubmit={submit}>
          <input
            className="input"
            type="text"
            autoComplete="username"
            placeholder={t('Username')}
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            readOnly={Boolean(usernameFromPath)}
            required
          />
          <input
            className="input"
            type="password"
            autoComplete="current-password"
            placeholder={t('Password')}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
          <button className="btn btn-primary" type="submit" disabled={loading}>
            {loading ? t('Loading...') : t('Login')}
          </button>
        </form>
      </div>
    </div>
  );
}